export default "__VITE_ASSET__HdYr20Kp__"